<template>
  <div class="page-header bg-white border-b border-gray-200 border-solid border-b">
    <div class="container">
      <header class="xl:flex xl:justify-between xl:items-center py-8  ">
        <div>
          <div v-if="categories"> 
            <ol class="breadcrumbs mb-4 text-sm opacity-75">
              <li v-if="categories.level_1">
                {{ categories.level_1.title }}
              </li>
              <li v-if="categories.level_2">
                {{ categories.level_2.title }}
              </li>
              <li v-if="categories.level_3">
                {{ categories.level_3.title }}
              </li>
            </ol>
          </div>
          <h1 class="text-3xl md:text-4xl  uppercase font-semibold leading-none  text-whitse">
            {{ title }}
          </h1>
        </div>
        <div class="codes flex text-center mt-3 md:mt-0">
          <product-code :value="uom" label="UOM" />
          <product-code :value="impaCode" label="IMPA Code" />
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import ProductCode from './ProductCode'


export default {
  components: {
    ProductCode
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    categories: {
      type: Object,
      default:  () => {
        level_1: {
          title : ''
        }
        level_2: {
          title : ''
        }
        level_3: {
          title : ''
        }
      }
    },
    uom: {
      type: String,
      default: 'XXX'
    },
    impaCode: {
      type: String,
      default: 'XXXXX'
    }
  },
}
</script>

<style>
  .breadcrumbs li {
    @apply inline;
  }
  .breadcrumbs li + li:before {
    content: '/';
    @apply mx-1;
  }
</style>
